import axios from "axios";

export async function addPupilsToTargetGroup(groupId, pupilIds) {
    try {
        const response = await axios.post(`/targetGroups/level2/${groupId}/pupils`, { pupilIds });
        return response.data;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка добавления учеников";
        throw new Error(text);
    }
}
